import React from 'react';
import NhiemVuTTXM from './NhiemVuTTXM.jsx';
import ConfirmDialog from './ConfirmDialog.jsx';
import moment from 'moment';
import { connect } from 'react-redux';
import { ShowIf } from 'components/utils';
import {TextArea} from 'components/tt-forms/common';
import { GiaiQuyetDonThu } from 'api';
import {Link} from 'react-router';
import {ContainerFileDinhKem} from 'components/upload';
import {
  getParams
} from 'modules/giai-quyet-don/subView/GetParams.jsx';
import {BlockGiaiQuyetDonInfo} from 'modules/giai-quyet-don/subView';

const loaiTepDinhKem = 'QUYET_DINH';
const loaiQuyTrinh = 'GIAI_QUYET_DON';

class CanBoGiaiQuyetYeuCauLapDuThao extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      btnLoading: false,
      btnSaveLoading: false,
      openDialog: false,
      openDialogTruongPhongGiaiQuyetDon: false,
      openDialogTruongPhongTTXM: false,
      onSave: false,
      id: this.props.id,
      role: this.props.role,
      loaiDon: this.props.loaiDon,
      validate: false,
      showAttach: false,
      yKienGiaiQuyet: '',
      noiDungKetLuanDuThao: '',
      canBoGiaiQuyet: '',
      ngayHetHanGiaiQuyet: '',
      ngayHetHanKTDX: '',
      phongBanGiaiQuyet: '',
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: {
        giaHan: [],
        data: []
      },
      dataTaiLieuVanThuDelete: [],
      thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
      coQuanQuanLyId: this.props.coQuanQuanLyId,
      coQuanQuanLyNguoiDung: this.props.coQuanQuanLyNguoiDung,
      nextState: 'CAN_BO_CHUYEN_DU_THAO_VE_DON_VI_GIAI_QUYET',
      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: [],
    }
  }

  componentDidMount() {
    this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      loaiDon: nextProps.loaiDon
    })
  }

  componentWillUnmount() {

  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    });
    if (name== 'nextState') {

    }
    this.props.handleChangeData();
  }

  getThongTinGiaiQuyetDon(id) {
    if(typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
      let params = {
        id: id
      };
      GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(res => {
        if(res.data) {
          this.setState({
            dataGiaiQuyetDon: res.data,
            canBoGiaiQuyet: res.data.canBoXuLyChiDinhInfo ? res.data.canBoXuLyChiDinhInfo.congChucId : '',
            noiDungKetLuanDuThao: res.data.noiDungKetLuanDuThao ? res.data.noiDungKetLuanDuThao : '',
            ngayHetHanGiaiQuyet: res.data.ngayHetHanGiaiQuyet ? new Date(res.data.ngayHetHanGiaiQuyet) : '',
            ngayHetHanKTDX: res.data.ngayHetHanKTDX ? new Date(res.data.ngayHetHanKTDX): ''
          },()=> {
            this.renderAttachFile()
          });
        }
      });
    }
  }

  onClickClose() {
    this.props.handleBack();
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
    this.props.handleChangeData();
  }

  getParams() {
    let dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;

    let params = getParams(dataGiaiQuyetDon, this.state.id);

    params.noiDungKetLuanDuThao = this.state.noiDungKetLuanDuThao;
    return params;
  }

  handleSave(type){
    this.setState({
      onSave: true
    }, () => {

      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });
      let dataFileDinhKem = this.getListDataFileDinhKem();
      if (dataFileDinhKem.length > 0) {
        dataFileDinhKem.map((item, i) => {
          if (item.taiLieuVanThuId) {
            this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
              don: {
                id: Number(this.state.id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: item.loaiTepDinhKem,
              loaiQuyTrinh: item.loaiQuyTrinh,
              buocGiaiQuyet: item.buocGiaiQuyet,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
              don: {
                id: Number(this.state.id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: loaiTepDinhKem,
              loaiQuyTrinh: loaiQuyTrinh,
              buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          }
        });
      }

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }

      let params = this.getParams();

      params.noiDungKetLuanDuThao = this.state.noiDungKetLuanDuThao;
      this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
        this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
          this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
            this.props.saveGiaiQuyetDon(params);
          });
        });
      });
    })
  }

  handleGiaiQuyetDon(type) {
    this.setState({
      onSave: false
    }, ()=> {
      if(this.validateSubmitForm()) {
        this.setState({
          isOpen: false,
          btnLoading: true
        });
        let dataFileDinhKem = this.getListDataFileDinhKem();

        if (dataFileDinhKem.length > 0) {
          dataFileDinhKem.map((item, i) => {
            if (item.taiLieuVanThuId) {
              this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(this.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(this.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: loaiQuyTrinh,
                buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });
        }

        if (this.state.dataTaiLieuVanThuDelete.length > 0) {
          this.state.dataTaiLieuVanThuDelete.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }

        let _params = this.getParams();
        let params = {};
        if (this.props.tuGiaiQuyet == true) {
          params = {
            thongTinGiaiQuyetDon: {
              id: Number(this.state.thongTinGiaiQuyetDonId)
            },
            actionType: 'TTXM_GUI_DU_THAO',
            yKienGiaiQuyet: this.state.noiDungKetLuanDuThao
          }
        } else {
          let selectedState = this.props.dataNextStates.filter(state => {
            return state.type == this.state.nextState
          });

          params = {
            thongTinGiaiQuyetDon: {
              id: Number(this.state.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            yKienGiaiQuyet: this.state.noiDungKetLuanDuThao
          }
        }
        this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
          this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
            this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
              this.props.updateGiaiQuyetDon(_params, params, 'gqdGuiDuThao');
            });
          });
        });
      }
    })
  }

  onFileChange(data, type) {
    if (type == 'GIA_HAN') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.giaHan = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.data = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    }
    this.props.handleChangeData();
  }

  onFileRemove(id, data, type) {
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    });

    if (type == 'GIA_HAN') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.giaHan = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.data = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    }
    this.props.handleChangeData();

  }

  getListDataFileDinhKem() {
    let dataFileDinhKem = []
    let Data = this.state.dataFileDinhKem;

    if (Data.data.length > 0) {
      Data.data.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (Data.giaHan.length > 0 ) {
      Data.giaHan.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    return dataFileDinhKem;
  }

  // Cap nhat tep dinh kem
  updateTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {
        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Them tep dinh kem
  postTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {
        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Xoa tep dinh kem
  deleteTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {
        }
        callback();
      });
    } else {
      callback();
    }
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  compareDate(firstDate, secondDate, type) {
    var firstTime = firstDate.getTime();
    var secondTime = secondDate.getTime()

    if (firstTime > secondTime || (firstTime == secondTime && type == 'show')) {
      return true
    } else {
      return false
    }
  }

  renderAttachFile() {
    let DataTaiLieuVanThu = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
    let DataTaiLieuVanThuView = [...this.props.listTaiLieuVanThuGiaiQuyetDon];

    let listTaiLieuVanThuGiaiQuyetDon = DataTaiLieuVanThu.filter(state => {
      return this.compareDate(new Date(state.ngayTao), new Date(this.state.dataGiaiQuyetDon.ngayBatDauGiaoLapDuThao), 'action');
    })

    let listTaiLieuVanThuGiaiQuyetDonView = DataTaiLieuVanThuView.filter(state => {
      return this.compareDate(new Date(this.state.dataGiaiQuyetDon.ngayBatDauGiaoLapDuThao), new Date(state.ngayTao), 'show');
    })

    let data = [...listTaiLieuVanThuGiaiQuyetDon];
    let dataCheck = data.filter(item => {
      return item.required && item.typeRequired == 'DT_KL_GQKN'
    })
    if (dataCheck.length > 0) {
      this.setState({
        listTaiLieuVanThuGiaiQuyetDon:listTaiLieuVanThuGiaiQuyetDon,
        listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
        showAttach: true
      })
    } else {
      let DT_KL = {
        ten: this.state.loaiDon === 'DON_TRANH_CHAP_DAT' ? 'Dự thảo quyết định về việc giải quyết' : 'Dự thảo quyết định về việc giải quyết khiếu nại',
        loaiTepDinhKem: '',
        soQuyetDinh: '',
        ngayQuyetDinh: '',
        tenFile: '',
        duongDan: '',
        progress: 0,
        required: true,
        typeRequired: 'DT_KL_GQKN',
        newFile: true
      }
      let TT_KL = {
        ten:  this.state.loaiDon === 'DON_TRANH_CHAP_DAT' ? 'Tờ trình đề nghị ban hành QĐGQ' : 'Tờ trình đề nghị ban hành QĐGQ khiếu nại',
        loaiTepDinhKem: '',
        soQuyetDinh: '',
        ngayQuyetDinh: '',
        tenFile: '',
        duongDan: '',
        progress: 0,
        required: true,
        typeRequired: 'DT_KL_GQKN',
        newFile: true
      }
      this.setState({
        listTaiLieuVanThuGiaiQuyetDon: [
          ...this.state.listTaiLieuVanThuGiaiQuyetDon,
          TT_KL,
          DT_KL
        ],
        listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
        showAttach: true
      })
    }

  }

  openDialog(name) {
    if (this.validateSubmitForm()) {
      this.setState({
        openDialog: true
      })
    }
  }

  closeDialog() {
    this.setState({
      openDialog: false
    })
  }

  onSuccess(name) {
    this.setState({
      openDialog: false
    })
    this.handleGiaiQuyetDon();
  }

  render() {

    return (
      <section className="wrap-block">
        <NhiemVuTTXM
          donViGiaoThamTraXacMinh={this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo}
          ngayBatDauTTXM={this.state.dataGiaiQuyetDon.ngayBatDauTTXM}
          yKienCuaDonViGiaoTTXM = {this.state.dataGiaiQuyetDon.yKienCuaDonViGiaoTTXM}
          ngayHetHanTTXM={this.state.dataGiaiQuyetDon.ngayHetHanTTXM}
          donInfo={this.props.donInfo}
        />
        <div className="wrap-big-line pt5 pb15">
          <span className="big-border"></span>
        </div>
        <BlockGiaiQuyetDonInfo donInfo={this.props.donInfo} thongTinGQD={this.state.dataGiaiQuyetDon}/>

        <h2 className="title-14 mb15">Dự thảo quyết định giải quyết khiếu nại</h2>
        <form className="form-action">
          <div className="row pl10 pr10">
            <TextArea value={this.state.noiDungKetLuanDuThao} className="areal-wrap col-100" label="Tóm tắt nội dung kết quả đối thoại" placeholder="Nhập..." onChange={this.onChange.bind(this, 'noiDungKetLuanDuThao')} name="textareaChonCanBoGiaiQuyet"/>
            <ShowIf condition={this.state.showAttach}>
              <div className="col-100 pb5">
                <ContainerFileDinhKem onSave={this.state.onSave} label="Danh sách văn bản xử lý" bindValidator={this} dataShow={this.state.listTaiLieuVanThuGiaiQuyetDonView} data={this.state.listTaiLieuVanThuGiaiQuyetDon} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
              </div>
            </ShowIf>
          </div>
          <div className="box-bottom">
            <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
            <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this, 'truongPhongGiaiQuyetDon')}><span>Lưu tạm</span></Link>
            <Link style={{right: 0}} className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline') : "btn-action btn-move action-todo"} onClick={this.openDialog.bind(this)}><span>Gửi dự thảo</span></Link>
            <ConfirmDialog open={this.state.openDialog} onClose={this.closeDialog.bind(this)} onSuccess={this.onSuccess.bind(this)} title="Xác nhận" content={"Bạn có đồng ý chuyển cho " + (this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViGiaoThamTraXacMinhInfo.ten : '') +" dự thảo của đơn/vụ việc này không?"}/>

          </div>
        </form>
      </section>
    );
  }
}

CanBoGiaiQuyetYeuCauLapDuThao.defaultProps = {
  ketQuaGiaiQuyetDon: [],
  validators: {
    formTaoDon: []
  }
}

let bindStateToProps = state => {
  return {
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  }
}

export default connect(bindStateToProps)(CanBoGiaiQuyetYeuCauLapDuThao)


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/CanBoGiaiQuyetYeuCauLapDuThao.jsx